import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const getUnreviewedBookings = async () => {
  return await apiClient.get(`${ENDPOINTS.BOOKINGS}/unreviewed`);
};
